/*eslint-disable*/
// selectors
  export const selectBulkTransactionId = (state) => state.uploadRequests.transactionId

  export const selectBulkFileName = (state) => state.uploadRequests.fileName

  export const selectBulkStatus = (state) => state.uploadRequests.status

  export const selectBulkError = (state) => state.uploadRequests.error

  export const selectJobId = (state) => state.uploadRequests.jobId